import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/configs/axios.config'
import type { ActualVsBudgetPeriod } from '@/features/actual-vs-budget-production/types'
import { getPortfolioActualVsBudget } from '@/services/actual-vs-budget.service'

export function usePortfolioActualVsBudget(period: ActualVsBudgetPeriod) {
  return useQuery({
    queryKey: ['companies', 'actual-vs-budget', period],
    queryFn: () => getPortfolioActualVsBudget(period, httpClient),
    staleTime: 30_000,
  })
}
